import {
    WpIndividual,
    WpPeopleDetail,
    WpViewDistributionTooltipData,
} from '../../core';
import { TranslationKeyMap } from '../main.i18n';

export function createDistributionTooltipData(
    row: WpIndividual | WpPeopleDetail,
): WpViewDistributionTooltipData[] {
    return [
        {
            title: TranslationKeyMap._10085_WINNING,
            percentage: row?.winning,
            number: row?.winningNumber,
            classList: 'cmps-cdk-bg-gradient-green-100-0',
        },
        {
            title: TranslationKeyMap._11154_IMPROVING,
            percentage: row?.neutral,
            number: row?.neutralNumber,
            classList: 'cmps-cdk-bg-gradient-grey-400-0',
        },
        {
            title: TranslationKeyMap._11155_DECLINING,
            percentage: row?.losing,
            number: row?.losingNumber,
            classList: 'cmps-cdk-bg-gradient-red-100-0',
        },
    ];
}
